import React from 'react';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import Description from './Description';
import VideoPlayer from './VideoPlayer';
import { VideoUploadPageProps } from './interfaces';

const VideoUploadPage = ({
  env,
  initialCurrentUser,
  isGdprRequired,
  isWebview,
  videoUpload,
}: VideoUploadPageProps) => {
  const { Track } = useEventTracking({
    page: Page.VideoUpload,
    contentId: videoUpload.guid,
  });

  return (
    <Track>
      <AppContextProvider
        initialCurrentUser={initialCurrentUser}
        isGdprRequired={isGdprRequired}
        isWebview={isWebview}
        env={env}
      >
        <VideoPlayer video={videoUpload} />
        <div className="mt-40 px-28">
          <div className="m-auto max-w-container-lg">
            {videoUpload.description && <Description description={videoUpload.description} />}
          </div>
        </div>
      </AppContextProvider>
    </Track>
  );
};

export default VideoUploadPage;
